import { cn } from '~/lib/utils'
import { Check } from 'lucide-react'
import { Step } from '~/types'
import { Link } from '@remix-run/react'
import { useSetAtom } from 'jotai'
import { isLoadingAtom } from '~/lib/jotai/loading'

interface Props {
    currentStep: number
    steps: Step[]
}

const Stepper = ({ currentStep, steps }: Props) => {
    const setLoading = useSetAtom(isLoadingAtom)

    return (
        <nav className='w-full flex justify-center mb-10'>
            <ol className='py-4 grid grid-cols-1 gap-3 min-[400px]:grid-cols-2 sm:grid-cols-3 lg:flex lg:gap-7'>
                {steps.map((step, index) =>
                    index <= currentStep ? (
                        <Link
                            to={step.slug}
                            key={step.slug}
                            onClick={() => {
                                if (index != currentStep) {
                                    setLoading(true)
                                }
                            }}
                        >
                            <li
                                //key={step.slug}
                                className=''
                            >
                                <div
                                    aria-current={
                                        currentStep === index
                                            ? 'step'
                                            : undefined
                                    }
                                    className='flex gap-2 items-center font-semibold hover:cursor-pointer group'
                                >
                                    <span
                                        className={cn(
                                            'rounded-full transition-all duration-200 ease-in-out  text-white',
                                            currentStep === index
                                                ? 'bg-companyRed ring-4 ring-red-300'
                                                : 'bg-slate-400 group-hover:bg-slate-900',
                                            currentStep > index
                                                ? 'p-1 bg-companyRed'
                                                : 'py-1 px-3'
                                        )}
                                    >
                                        {currentStep <= index && index + 1}
                                        {currentStep > index && (
                                            <Check className='h-6 w-6' />
                                        )}
                                    </span>
                                    <span
                                        className={cn(
                                            'group-hover:text-slate-900',
                                            currentStep === index
                                                ? 'text-slate-900'
                                                : 'text-slate-400',
                                            currentStep > index
                                                ? 'text-red-500'
                                                : ''
                                        )}
                                    >
                                        {step.title}
                                    </span>
                                </div>
                            </li>
                        </Link>
                    ) : (
                        <li key={step.slug} className=''>
                            <div
                                aria-current={
                                    currentStep === index ? 'step' : undefined
                                }
                                className='flex gap-2 items-center font-semibold'
                            >
                                <span
                                    className={cn(
                                        'rounded-full transition-all duration-200 ease-in-out text-white',
                                        currentStep === index
                                            ? 'bg-red-500 ring-4 ring-red-300'
                                            : 'bg-slate-400',
                                        currentStep > index
                                            ? 'p-1 bg-red-500'
                                            : 'py-1 px-3'
                                    )}
                                >
                                    {currentStep <= index && index + 1}
                                    {currentStep > index && (
                                        <Check className='h-6 w-6' />
                                    )}
                                </span>
                                <span
                                    className={cn(
                                        currentStep === index
                                            ? 'text-slate-900'
                                            : 'text-slate-400',
                                        currentStep > index
                                            ? 'text-red-500'
                                            : ''
                                    )}
                                >
                                    {step.title}
                                </span>
                            </div>
                        </li>
                    )
                )}
            </ol>
        </nav>
    )
}

export default Stepper
